/* eslint-disable @reatom/unit-naming-rule */
import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { match } from 'ts-pattern'
import { useMemo } from 'use-memo-one'

import { goBackAction } from '@root/features/routing/atoms'
import { CreateWalletFlow } from '@root/features/wallet/create-wallet/ui/create-wallet-flow'

import { reatomCreateWalletFlow } from '../../atoms/reatom-create-wallet-flow'

import { NewWalletHeader } from './new-wallet-header'

type NewWalletPageProps = {}

export const NewWalletPage: React.FC<NewWalletPageProps> = () => {
  const model = useMemo(() => reatomCreateWalletFlow(), [])
  const goBack = useAction(goBackAction)
  const [step, setStep] = useAtom(model.step)

  const handleBack = () =>
    match(step)
      .with('acknowledgements', () => {
        goBack()
      })
      .with('seed-phrase', () => {
        setStep('acknowledgements')
      })
      .with('seed-phrase-confirm', () => {
        setStep('seed-phrase')
      })
      .exhaustive()

  return (
    <Root>
      <NewWalletHeader onBack={handleBack} />
      <CreateWalletFlow model={model} />
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-1);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
